<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div class="m-portlet m-b-10" :style="{'height':(80)+'px'}">
            <div class="m-portlet__body">
                <el-form label-width="100px" style="width: 1200px">
                    <el-row :gutter="10">
                        <el-col :span="6">
                            <el-form-item label="筛选仓库">
                                <el-select v-model="filter.storeId" placeholder="仓库"
                                           filterable remote
                                           :remote-method="handelSearchStore"
                                           @change="handleChange()">
                                    <el-option
                                            v-for="item in warehouses"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="筛选学生">
                                <el-select v-model="filter.studentId" placeholder="学生" clearable
                                           filterable remote
                                           :remote-method="handelSearchByStudentName"
                                           @change="handleList()">
                                    <el-option
                                            v-for="item in students"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="筛选序列号">
                                <el-select v-model="filter.serialId" placeholder="序列号" clearable
                                           filterable remote
                                           :remote-method="handelSearchBySerialId"
                                           @change="handleList()">
                                    <el-option
                                            v-for="item in serials"
                                            :key="item.id"
                                            :label="item.serial_id"
                                            :value="item.serial_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10" :style="{'height':(260)+'px'}">
            <div class="m-portlet__body" :style="{'height':250+'px'}" v-loading="loading">
                <el-row :gutter="10">
                    <el-col :span="16">
                        <el-table
                                :data="shops"
                                style="width: 100%"
                                size="middle"
                                :height="200"
                        >
                            <el-table-column prop="name" label="商品名"></el-table-column>
                            <el-table-column prop="total" label="总出售"></el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="m-portlet" :style="{'height':(clientHeight-460)+'px'}">
            <div class="m-portlet__body" :style="{'height':clientHeight-550+'px'}" v-loading="loading">
                <el-table
                        :data="orderLeaseInventory"
                        style="width: 100%"
                        size="middle"
                        :height="clientHeight-550"
                >
                    <el-table-column prop="shopName" label="商品名称" min-width="15%"></el-table-column>
                    <el-table-column prop="description" label="描述" min-width="10%"></el-table-column>
                    <el-table-column prop="serial_id" label="序列号" min-width="10%"></el-table-column>
                    <el-table-column prop="sign" label="内部编号" min-width="10%"></el-table-column>
                    <el-table-column prop="created_at" label="首次入库时间" min-width="15%"></el-table-column>
                    <el-table-column prop="invoice_id" label="所属合同" min-width="10%"></el-table-column>
                    <el-table-column prop="student_id" label="租赁人ID" min-width="10%"></el-table-column>
                    <el-table-column prop="name" label="租赁人" min-width="10%"></el-table-column>
                    <el-table-column prop="price" label="价值" min-width="10%"></el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "SellList",
        data() {
            return {
                leaseInventory:[],
                shops:[],
                warehouses:[],
                students:[],
                serials:[],
                invoices:[],
                filter:{
                    date:'',
                    serialId:'',
                    sign:'',
                    categoryId:'',
                    storeId:'',
                    name:'',
                    studentId:''
                },
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                loading:false,
            }
        },
        created() {
            this.handleList();
            this.handleCountByShopName();
            this.handelSearchStore();
            this.handelSearchBySerialId();
            this.handelSearchByStudentName();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderLeaseInventory: function () {
                return this._.orderBy(this.leaseInventory, 'id', 'asc');
            }
        },
        methods: {
            handleList(currentPage = 1){
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.loading = true;
                this.$axios.get(store.state.server + '/getSellList?'+
                    'serialId='+this.filter.serialId +
                    '&storeId='+this.filter.storeId +
                    '&studentId='+this.filter.studentId +
                    '&page='+this.currentPage +
                    '&limit=' + this.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        if (Object.keys(response.data.content.list).length !== 0) {
                            this.leaseInventory=response.data.content.list
                        } else {
                            this.leaseInventory = new Object();
                        }
                        this.total=response.data.content.total
                        this.loading = false;
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleCountByShopName(){
                this.$axios.get(store.state.server + '/sellCount?storeId=' + this.filter.storeId
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.shops=response.data.content.shopNames
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleChange(){
                this.handleList();
                this.handleCountByShopName();
            },
            handelSearchStore(val=''){
                this.$axios.get(store.state.server + '/searchByStoreName?storeName=' +val+'&type=1').then((response) => {
                    if (response.data.code == '0000') {
                        this.warehouses=response.data.content.storeName
                        if(!this.filter.storeId){
                            this.filter.storeId=this.warehouses[0].id
                            this.handleChange()
                        }
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchBySerialId(val=''){
                this.$axios.get(store.state.server + '/searchBySerialId?serialId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.serials=response.data.content.shops
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchByStudentName(val=''){
                this.$axios.get(store.state.server + '/searchByStudentName?studentName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.students=response.data.content.students
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleCargo(){

            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>